<!-- <div class="grid-fluid">
  <div class="footer-block" *ngFor="let node of nodes">
    <h3>{{node.title}}</h3>
    <ul>
      <li *ngFor="let item of node.children">
        <a class="link" [href]="item.url" [title]="item.tooltip || item.title">{{ item.title }}</a>
      </li>
    </ul>
  </div>
</div> -->

<p>
  Energy Industries Council ©2023.
</p>


